module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av172-965340db92804d69691840e615ee5675.jpg";